import { render, staticRenderFns } from "./FieldNumber.vue?vue&type=template&id=2dc0fe9f&"
import script from "./FieldNumber.vue?vue&type=script&lang=js&"
export * from "./FieldNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports